import { QualityPromise } from "../components/QualityPromise";
import { Services } from "../components/Services";
import { Farbwelt } from "../components/Farbwelt";
import { CtaBand } from "../components/CtaBand";
import { useTitle } from "../components/Reveal";

export default function Leistungen() {
  useTitle("Leistungen – Manfred Berglar · Malermeister seit 1925");
  return (
    <div className="bg-white text-ink overflow-x-clip">
      <h1 className="sr-only">Leistungen – Manfred Berglar, Malermeister in Olpe-Griesemert, seit 1925</h1>
      <div className="pt-[76px] md:pt-[88px]">
        <QualityPromise />
        <Services />
        <Farbwelt />
        <CtaBand
          title="Ihr Vorhaben in erfahrenen Händen."
          text="Von der Beratung bis zur sauberen Übergabe – klar, ruhig, verbindlich."
        />
      </div>
    </div>
  );
}
